import { FullStory } from '@fullstory/browser';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { FS_EVENTS } from 'src/@types';
import { LOC_NS, ORDERS_KEYS } from 'src/i18n/types';
import { styled } from 'src/stitches.config';
import { Button } from './Button';
import Modal from './Modal';

interface Props {
  open: boolean;
  onClose: () => void;
  robotSerial: string;
  hasDesignatedRobot: boolean;
}

const Copy = styled('p', {
  padding: '$1 $0',
  fontSize: '$5',
  fontWeight: '500',
  lineHeight: '1.5',
});

export const DifferentRobotAlert = ({ open, onClose, robotSerial, hasDesignatedRobot }: Props) => {
  const { t } = useTranslation(LOC_NS.ORDERS);
  const searchParams = useSearchParams();
  const scannedRobotSerial = searchParams.get('cocoId');

  useEffect(() => {
    if (open) {
      FullStory('trackEvent', {
        name: FS_EVENTS.DIFFERENT_ROBOT_ALERT_OPEN,
        properties: {
          resolvedRobotSerial: robotSerial,
          scannedRobotSerial,
        },
      });
    }
  }, [open, robotSerial, scannedRobotSerial]);

  return (
    <Modal isOpen={open}>
      <Copy>
        {hasDesignatedRobot
          ? t(ORDERS_KEYS.DIFFERENT_ROBOT_OPENED_UBER, {
              robotSerial,
              defaultValue: `Robot ${robotSerial} has been assigned to this order. Opening lid of ${robotSerial} now.`,
            })
          : t(ORDERS_KEYS.DIFFERENT_ROBOT_OPENED_NON_UBER, {
              scannedRobotSerial,
              openedRobotSerial: robotSerial,
              defaultValue: `Robot ${scannedRobotSerial} failed to open. Opening lid of ${robotSerial} instead.`,
            })}
      </Copy>
      <Button onClick={onClose} style={{ marginTop: '1rem' }}>
        {t(ORDERS_KEYS.GOT_IT, 'Got it!')}
      </Button>
    </Modal>
  );
};
